export const START_SCROLLING = 'scrollToComponent/startScrolling';
export const STOP_SCROLLING = 'scrollToComponent/stopScrolling';